/**
 * Reusable table component with headers, data, and custom row rendering.
 * Supports loading states, empty states, and responsive design.
 * Provides consistent table styling across all data display pages.
 * Used in all main pages (Patients, Enrollments, Users, Medical Centers, Call Sessions).
 */


import React from 'react';

const Table = ({ 
  headers = [], 
  data = [], 
  renderRow, 
  emptyMessage = "No data available",
  className = "",
  loading = false
}) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        <p className="text-gray-500 mt-2">Loading...</p>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center">
        <p className="text-gray-500">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className={`min-w-full divide-y divide-gray-200 ${className}`}>
          <thead className="bg-gray-50">
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data.map((row, index) => renderRow(row, index))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;